


















































import { Component, Vue } from 'vue-property-decorator';
@Component({})
  export default class FrameC extends Vue {
    /* TODO: Move data to service & use correct images */
    private data() {
      return {
        items: [
          {
            src: 'https://firebasestorage.googleapis.com/v0/b/danko-v1.appspot.com/o/carousel%2Fgood-vibes_308x350.jpg?alt=media&token=20e03b45-292a-43ae-b87b-6f403c00176e',
            height: '350px',
            top: '0',
            background: '#331f19',
            text: 'Manufactured using only the finest California Primo produced by the best growers in the world.',
            link: 'http://google.com',
            buttonText: 'Read more...',
            knockout: true,
            serif: true
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
        ],
        frameThree: {
          gearA: {
            url: require('../../assets/home-mech/frame-C/gear-G_132x132.png'),
            alt: 'frame three gear A',
            highlight: require('../../assets/home-mech/frame-C/gear-G-high_132x132.png'),
            highAlt: 'frame three gear A highlight',
          },
          gearB: {
            url: require('../../assets/home-mech/frame-C/gear-H_70x70.png'),
            alt: 'frame three gear B',
            highlight: require('../../assets/home-mech/frame-C/gear-H-high_70x70.png'),
            highAlt: 'frame three gear B highlight',
          },
          gearC: {
            url: require('../../assets/home-mech/frame-C/gear-I_82x82.png'),
            alt: 'frame three gear C',
            highlight: require('../../assets/home-mech/frame-C/gear-I-high_82x82.png'),
            highAlt: 'frame three gear C highlight',
          },
          gearD: {
            url: require('../../assets/home-mech/frame-C/gear-J_188x188.png'),
            alt: 'frame three gear D',
            highlight: require('../../assets/home-mech/frame-C/gear-J-high_188x188.png'),
            highAlt: 'frame three gear D highlight',
          },
          gearE: {
            url: require('../../assets/home-mech/frame-C/gear-K_88x88.png'),
            alt: 'frame three gear E',
            highlight: require('../../assets/home-mech/frame-C/gear-K-high_88x88.png'),
            highAlt: 'frame three gear E highlight',
          },
          gearF: {
            url: require('../../assets/home-mech/frame-C/gear-L_36x36.png'),
            alt: 'frame three gear F',
            highlight: require('../../assets/home-mech/frame-C/gear-L-high_36x36.png'),
            highAlt: 'frame three gear F highlight',
          },
        },
      };
    }
  }
